// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../../components/Button';
import ReplyField from '../ReplyFIeld';

const S = {
  Wrapper: styled.div`
    overflow: hidden;
    position: relative;
    width: 100%;
    display: flex;
    flex-grow: 1;
  `,
  ChatFieldWrapper: styled.div`
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.161);
    border-radius: 4px;
  `,
  ChatWrapper: styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 0 22px 14px 14px;
  `,
  ChatField: styled.div`
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 7px;
    overflow: auto;
    margin-bottom: auto;
  `,
  ReplyField: styled(ReplyField)`
    flex-shrink: 0;
    margin-top: 32px;
  `,
  Image: styled.img`
    height: 100%;
  `,
  //////////////////////////////////
  Container: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
    height: 453px;
    background: #FFFFFF;
    box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.161);
    border-radius: 4px;
    padding: 24px;
  `,
  TitleText: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 22px;
    line-height: 32px;
    text-align: center;
    color: #313131;
    margin-bottom: 14px;
    margin-top: 24px;
  `,
  DescriptionText: styled.div`
    justify-content: center;
    align-items: center;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #313131;
    margin-bottom: 28px;
  `,
  Resend: styled.a`
    color: #EF8200;
    cursor: pointer;
    text-decoration-line: underline;
    text-underline-offset: 2px;
  `,
  ButtonBackDefault: styled(Button)`
    cursor: pointer;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    width: 142px;
    height: 44px;
    `,
  HeaderWrapper: styled.div`
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    height: 72px;
    width: 100%;
    background: rgba(252, 160, 50, 0.1);
    padding: 12px 24px 12px 24px;
    align-items: center;
    text-align: center;
  `,
  HeaderTextWrapper: styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
  HeaderSupportTitle: styled.div`
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    text-align: left;
  `,
  HeaderSupportCatagory: styled.div`
    font-size: 14px;
    line-height: 20px;
    color: #848484;
    text-align: left;
    display: inline-flex;
    align-items: center;
    text-align: center;
  `,
  Tag: styled.div`
    font-size: 12px;
    line-height: 12px;
    color: #4DAB3D;
    align-items: center;
    text-align: center;
    display: flex;
  `,
};

export { S as default };

